export default __webpack_public_path__ + "public/assets/images/19f3e52158f34bfafb92714df16dca7e.svg";